import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as y from 'yup'
import Input from './Input'
import emailjs from '@emailjs/browser'

export interface IForm {
    email: string
    message: string
}

const formSchema = y.object().shape({
    email: y
        .string()
        .trim()
        .email('Email není ve správném tvaru.')
        .required('* Pole je povinné.'),
    message: y.string().trim().required('* Pole je povinné.'),
})

export default function ContactForm() {
    const {
        register,
        watch,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm<IForm>({
        mode: 'all',
        reValidateMode: 'onBlur',
        resolver: yupResolver(formSchema),
    })

    const submitForm = (data: IForm) => {
        emailjs
            .send(
                'service_sz2afzf',
                'template_rns6phm',
                data as Record<string, any>,
                'wZ-guyfVuBq-M1VSk'
            )
            .then(
                (response) => {
                    console.log('SUCCESS!', response.status, response.text)
                    reset()
                },
                (err) => {
                    console.log('FAILED...', err)
                    reset()
                }
            )
    }

    return (
        <>
            <form onSubmit={handleSubmit(submitForm)}>
                <div className="sm:w-1/2">
                    <Input
                        type="text"
                        name="email"
                        label="E-mail"
                        value={watch('email')}
                        register={register}
                        error={errors['email']?.message}
                    />
                </div>
                <Input
                    type="textarea"
                    name="message"
                    label="Zpráva"
                    value={watch('message')}
                    register={register}
                    error={errors['message']?.message}
                />
                <div className="flex justify-end mt-2">
                    <button
                        type="submit"
                        className="text-xl font-heading font-bold uppercase hover:text-red-600 duration-200"
                    >
                        Odeslat
                    </button>
                </div>
            </form>
        </>
    )
}
